import './index.css'
import React from 'react';
import InputLabel from '../common/InputLabel';


export default function BasicData(props: any) {
  const action = props.action
  const handleChange = props.handleChange
  const siteForm = props.siteForm

  return (
    <React.Fragment>
      <div className='site-form-section'>
        <div className='site-form-section-title'>
          <p>DATOS BÁSICOS</p>
        </div>

        <div className='site-form-section-item'>
          <InputLabel
            label='Nombre'
            placeholder="Nombre"
            disabled={action === 'view'}
            name='name'
            value={siteForm?.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className='site-form-section-address'>
          <InputLabel
            label='Dirección'
            placeholder="Dirección"
            disabled={action === 'view'}
            name='address'
            value={siteForm?.address}
            onChange={handleChange}
          />
        </div>

        <div className='site-form-section-item'>
          <InputLabel
            label='Latitud'
            placeholder="Latitud"
            disabled={action === 'view'}
            name='latitude'
            value={siteForm?.latitude}
            onChange={handleChange}
          />
        </div>

        <div className='site-form-section-item'>
          <InputLabel
            label='Longitud'
            placeholder="Longitud"
            disabled={action === 'view'}
            name='longitude'
            value={siteForm?.longitude}
            onChange={handleChange}
          />
        </div>
      
      </div>
    </React.Fragment>
  );
}
